/*eslint-disable array-callback-return */
/*eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import './index.scss';
import { AccountFilter } from './account-filter';
import APIEndpoints from '../../../api/APIEndpoints';
import { axiosInstance } from '../../../../api/axios';
import AccountDetails from './account-details';

const Accounts = (props) => {
  //Fetching account summary
  const fetchAccountSummary = async (oid, memType) => {
    setIsAPIFailed(false);
    const currentDate = new Date().toISOString().split('T')[0];
    try {
      const responseAccount = await axiosInstance.get(
        APIEndpoints.getSpendingSummaryResource() + memType + '/oid/' + oid,
      );
      const accountsNameOptions = [];
      const memberAccountSummaryData = responseAccount.data;
      memberAccountSummaryData.Response.SpendingAccounts.map((account) => {
        accountsNameOptions.push({
          label: `${account.AccountType}`,
          value: account.AccountNumber,
          data: account,
        });
      });
      setAccountNames(accountsNameOptions);
      setActiveAccountName(accountsNameOptions[0]);
      await fetchAccountDetails(oid, memType, accountsNameOptions[0].value);
      setDataFetching(false);
      setIsAPIFailed(false);
      setIsNotFound(false);
    } catch (error) {
      console.log(error);
      setDataFetching(false);
      setIsAPIFailed(true);
      if (error.toString().includes('404')) {
        setIsNotFound(true);
      } else {
        setIsNotFound(false);
      }
    }
  };
  //Fetching Transaction Details of an account
  const fetchAccountDetails = async (oid, memType, activeAccount) => {
    const currentDate = new Date(selectBenefitYear.value)
      .toISOString()
      .split('T')[0];
    try {
      const activeAccountNumber = activeAccount;
      const responseAccountDetails = await axiosInstance.get(
        APIEndpoints.getAccountDetailsResource() +
          memType +
          '/oid/' +
          oid +
          '/accountnumber/' +
          activeAccountNumber +
          '/currentDate/' +
          currentDate,
      );

      setSpendingAccountDetails(
        responseAccountDetails.data.Response.SpendingAccountDetail,
      );
      setDataFetching(false);
      setIsAPIFailed(false);
      setIsNotFound(false);
    } catch (error) {
      console.log(error);
      if (error.toString().includes('404')) {
        setIsNotFound(true);
      }
      setDataFetching(false);
      setIsAPIFailed(true);
    }
  };
  //This is for list of accounts and active accounts and account details
  const [accountNames, setAccountNames] = useState([]);
  const [activeAccountName, setActiveAccountName] = useState('');
  const [spendingAccountDetails, setSpendingAccountDetails] = useState();
  const [isNotFound, setIsNotFound] = useState(false);
  //This is for plan details and coverage history
  const [planDetails, setPlanDetails] = useState([]);
  const [coverageData, setCoverageData] = useState([]);
  //This is for benefit year filter
  const [selectBenefitYear, setSelectBenefitYear] = useState({
    label: '01 Jan 2022 - 31 Dec 2022',
    value: '2022',
  });

  //These are for data fetching and if API Fails
  const [dataFetching, setDataFetching] = useState(false);
  const [isAPIFailed, setIsAPIFailed] = useState(false);

  const accountChangeHandler = (e) => {
    setIsAPIFailed(false);
    const selectedIndex = accountNames.findIndex(
      (account) => account.value === e.value,
    );
    setActiveAccountName(accountNames[selectedIndex]);
  };
  const benefitYearChangeHandler = (selectedValue) => {
    setSelectBenefitYear(selectedValue);
    setDataFetching(true);
    fetchAccountSummary(activeOID, memberType);
  };
  const benefitYearProps = {
    options: [
      { label: '01 Jan 2022 - 31 Dec 2022', value: '2022' },
      { label: '01 Jan 2021 - 31 Dec 2021', value: '2021' },
      { label: '01 Jan 2020 - 31 Dec 2020', value: '2020' },
    ],
    selectedBenefitYear: selectBenefitYear,
  };

  const { userOID, memberType } = props;

  const [activeOID, setActiveOID] = useState(userOID);

  useEffect(() => {
    setDataFetching(true);
    setAccountNames([]);
    if (!props.isFamilySelected && props.memberType !== 'Dependent') {
      fetchAccountSummary(props.userOID, props.memberType);
    } else {
      if (props.memberType === 'Dependent') {
        setIsAPIFailed(true);
        setIsNotFound(false);
      }
      if (props.isFamilySelected) {
        setIsAPIFailed(true);
        setIsNotFound(true);
      }
    }
  }, [props.userOID, props.isFamilySelected, props.memberType]);
  const isMounting = React.useRef(true);
  useEffect(() => {
    if (activeAccountName.value) {
      setDataFetching(true);
      fetchAccountDetails(activeOID, memberType, activeAccountName.value);
    }
  }, [props.userOID, activeAccountName]);

  return (
    <>
      <div className="account-info">
        {accountNames?.length > 0 && (
          <div className="account-filter-container mt-2 mb-md-4 mb-xs-3">
            <div className="container-offset">
              <AccountFilter
                AccountNames={accountNames}
                AccountChangeHandler={accountChangeHandler}
                ActiveAccountName={activeAccountName}
                benefitYearProps={benefitYearProps}
                benefitYearChangeHandler={benefitYearChangeHandler}
              />
            </div>
          </div>
        )}
        <div className="account-details">
          <AccountDetails
            {...spendingAccountDetails}
            planDetails={props?.planDetails}
            coverageData={props?.coverageData}
            dataFetching={dataFetching}
            isAPIFailed={isAPIFailed}
            activeMemType={props.memberType}
            activeOID={activeOID}
            membersCovered={props.membersCovered}
            preserveData={props.preserveData}
            coverageDataAPI={props?.isAPIFailed}
            coverageDataisNotFound={props?.isNotFound}
            isNotFound={isNotFound}
            isFamilySelected={props.isFamilySelected}
            activeAccountName={activeAccountName}
          />
        </div>
      </div>
    </>
  );
};

export default Accounts;
